import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useAsyncEffect } from './support/useAsyncEffect';
import { RecordingState } from './recording/RecordingState';
import { HistoryViewModel } from './support/HistoryViewModel';
import { useSubscription } from '@meraki-internal/state';
import { useSwitchCareMap } from './utils/useSwitchCareMap';
import { ConnectCalendarViewModel } from './appointments/ConnectCalendarViewModel';

export const GlobalActionHandler: FC<{ show?: boolean }> = ({ show = false }) => {
    const recordingState = useInstance(RecordingState);
    const connectCalendarVM = useInstance(ConnectCalendarViewModel);

    const history = useInstance(HistoryViewModel);
    useSubscription(() => history);

    const switchCareMap = useSwitchCareMap();

    useAsyncEffect(async () => {
        const globalAction = history.popSearchParam({ key: 'global-action' });
        if (globalAction) {
            switch (globalAction) {
                case 'start-recording':
                    const apptId = history.popSearchParam({ key: 'appt-id' });
                    const careMapId = history.popSearchParam({ key: 'id' });

                    // switch and wait until it's done
                    if (careMapId) {
                        await switchCareMap(careMapId);
                    }

                    recordingState.triggerRecording({
                        appointmentId: apptId,
                        initiatedFrom: 'Notification',
                        recordingContext: 'at-appointment'
                    });

                    break;

                case 'connect-calendar':
                    connectCalendarVM.open('notification');
                    break;

                default:
                    throw Error('Unsupported global-action');
            }
        }
    }, [history, history.state]);

    return null;
};
